'use strict';

(function() {
	const slider = document.querySelector('.hero-slider');
	if (!slider) return;

	const slides = [...slider.querySelectorAll('.hero-slider .slides > .slide')];
	const indicators = [...slider.querySelectorAll('.hero-slider .indicators > .indicator')];
  const duration = parseInt(slider.dataset.duration) || 5000;

	let index = 0;
	let startTime = 0;
	let elapsed = 0;
	let paused = false;
	let raf;

	function setProgress(pct) {
		const bar = indicators[index].querySelector('.indicator-bar > span');
		if (bar) bar.style.width = pct + '%';
	}

	function resetAll() {
		indicators.forEach(i => {
			i.classList.remove('selected');
			const bar = i.querySelector('.indicator-bar > span');
			if (bar) bar.style.width = '0%';
		});
		slides.forEach(s => s.classList.remove('selected'));
	}

	function activate(i) {
		cancelAnimationFrame(raf);
		elapsed = 0;
		index = i;

		resetAll();

		const selectedSlide = slides[index];
		if (!selectedSlide) return;

		selectedSlide.classList.add('selected');
		if (indicators[index]) indicators[index].classList.add('selected');

		if (selectedSlide.classList.contains('light')) {
			slider.setAttribute('data-theme', 'light');
		} else {
			slider.removeAttribute('data-theme');
		}

		startTime = performance.now();
		loop();
	}

	function loop(now = performance.now()) {
		if (!paused) {
			elapsed += now - startTime;
			startTime = now;

			const pct = Math.min((elapsed / duration) * 100, 100);
			setProgress(pct);

			if (elapsed >= duration) {
				activate((index + 1) % slides.length);
				return;
			}
		}
		raf = requestAnimationFrame(loop);
	}

	function pause() {
		paused = true;
	}

	function resume() {
		if (!paused) return;
		paused = false;
		startTime = performance.now();
	}

	document.addEventListener('visibilitychange', () => {
		if (document.hidden) pause();
		else resume();
	});

	[...slides, ...indicators].forEach(el => {
		el.addEventListener('mouseenter', pause);
		el.addEventListener('mouseleave', resume);
	});

	indicators.forEach((i, idx) => {
		i.addEventListener('click', () => activate(idx));
	});

	document.addEventListener('keydown', e => {
		if (e.key === 'ArrowLeft') activate((index - 1 + slides.length) % slides.length);
		if (e.key === 'ArrowRight') activate((index + 1) % slides.length);
	});

	let touchStartX = 0;
	const slidesContainer = slider.querySelector('.hero-slider .slides');

	if (slidesContainer) {
		slidesContainer.addEventListener('touchstart', e => {
			touchStartX = e.touches[0].clientX;
		}, { passive: true });

		slidesContainer.addEventListener('touchend', e => {
			const dx = e.changedTouches[0].clientX - touchStartX;
			if (Math.abs(dx) > 50) {
				activate(dx < 0 ? (index + 1) % slides.length : (index - 1 + slides.length) % slides.length);
			}
		}, { passive: true });
	}

	activate(0);
})();